// GET /api/me — contrato del endpoint de hidratación post-login.
//
// `ctx.puede_configurar_tenant` (decisión 2026-06-11): true para
// admin_tenant/super_admin (implícito por rol) y para directivos a los que
// Jidoka les otorgó el permiso (tenant_users.puede_configurar_tenant). El FE
// lo usa SOLO para mostrar/ocultar la sección "Configuración" — el gate duro
// es el middleware del API.
import { z } from 'zod';
import { FORMATO_LOTE_AYUDA_DEFAULT, FORMATO_LOTE_EJEMPLO_DEFAULT, FORMATO_LOTE_REGEX_DEFAULT, } from './formato_lote.js';
import { rolMantenimientoSchema } from './mantenimiento.js';
export const meResponseSchema = z.object({
    ctx: z.object({
        user_id: z.string().uuid(),
        tenant_id: z.string().uuid(),
        rol: z.string(),
        via_suplantacion: z.boolean().optional().default(false),
        puede_configurar_tenant: z.boolean(),
        // Capacidad "Corrección de datos con motivo" (decisión 2026-06-24). true para
        // coordinador (default) y para cualquier usuario con el flag otorgado. El FE
        // lo usa SOLO para mostrar/ocultar acciones de corrección — gate duro en API.
        puede_corregir_datos: z.boolean(),
        // Capacidad "Ver costos/rentabilidad" (WS-5). true para directivo/admin_tenant/
        // super_admin (siempre) y coordinador (default, revocable) o cualquier usuario
        // con el flag. El FE la usa SOLO para mostrar/ocultar precios/utilidad — gate
        // duro en API.
        puede_ver_costos: z.boolean(),
        // Capacidad "Ver módulo Mantenimiento" (fusión CMMS, informe §B/§G). true
        // para directivo/coordinador/admin_tenant/super_admin (default-on) o
        // cualquier usuario con el flag en tenant_users. El FE la usa SOLO para
        // mostrar/ocultar el nav del módulo — gate duro en API (requireCapability).
        puede_ver_mantenimiento: z.boolean(),
        // Capacidad "Usar el copiloto Jido" (jido-agent, ADR-J5). Rol-derivada:
        // SIN columna nueva en tenant_users en esta primera tajada (honra el
        // rollback "no schema changes" de la propuesta) — true SIEMPRE para
        // directivo/coordinador/super_admin, false para el resto. El FE lo usa
        // SOLO para mostrar/ocultar el FAB del copiloto; el gate duro es
        // requireRole('directivo','coordinador','super_admin') en
        // POST /api/jido/chat.
        puede_usar_copiloto: z.boolean(),
        // Roles de OPERACIÓN del módulo mantenimiento (filas activas en
        // usuarios_mantenimiento). Vacío = solo lectura (si además puede VER).
        roles_mtto: rolMantenimientoSchema.array(),
        // Unificación tiendas↔líneas: true cuando el backend sirve las superficies
        // unificadas (día-M en adelante). El FE lo usa para ocultar los carriles
        // legacy (TiendasCard S1, fila sintética C1, nav S8, etc.).
    }),
    user: z
        .object({
        id: z.string().uuid(),
        email: z.string(),
        nombre: z.string(),
        apellido: z.string(),
        activo: z.boolean(),
    })
        .nullable(),
    tenant: z
        .object({
        id: z.string().uuid(),
        nombre: z.string(),
        plan: z.string(),
        activo: z.boolean(),
        timezone: z.string(),
        atribucion_turno_cruce: z.enum(['dia_inicio', 'dia_fin']),
        dia_inicio_semana: z.number().int().min(1).max(7),
        /** Formato del lote de captura de la empresa (B7, migración 097). Los
         *  defaults reproducen la regla histórica de 8 dígitos. */
        formato_lote_regex: z.string().default(FORMATO_LOTE_REGEX_DEFAULT),
        formato_lote_ejemplo: z.string().default(FORMATO_LOTE_EJEMPLO_DEFAULT),
        formato_lote_ayuda: z.string().default(FORMATO_LOTE_AYUDA_DEFAULT),
    })
        .nullable(),
    /** Día operativo EN CURSO del tenant (YYYY-MM-DD) — LA definición de "Hoy"
     *  de toda la plataforma. Sigue al turno nocturno según la política de
     *  atribución (con dia_fin, a las 22:00 ya se opera el día siguiente).
     *  El FE lo usa como ancla de los presets "Hoy" vía useTenantConfig(). */
    dia_operativo_hoy: z.string(),
});
//# sourceMappingURL=me.js.map